import React from "react";
import PropTypes from "prop-types";
import ReactInterval from "react-interval";
import "moment/locale/ru";
import Moment from "react-moment";
import moment from "moment";
// import material-ui components
import Grid from "@material-ui/core/Grid";
import TablePagination from "@material-ui/core/TablePagination";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { DateTimePicker } from "@material-ui/pickers";
import withWidth, { isWidthUp} from "@material-ui/core/withWidth"
import { withStyles } from "@material-ui/styles";
//import @material-ui/icons
import ExcelIcon from "assets/jss/icons/FileExcel";
//redux components
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
//import core components
import Autocomplete from "components/Autocomplete/Autocomplete.jsx";
import Button from "components/CustomButtons/Button.jsx";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Table from "components/Table/Table.jsx";
import CustomInput from "components/CustomInput/CustomInput";

import { get_file } from "utils/http";

import * as actionCreators from "actions/orders";

import ordersStyle from "assets/jss/material-dashboard-react/views/ordersStyle";

const ordersOrderings = [{
    name: "ID автомата(по взрастанию)",
    order_by: "machine_id",
    desc: false,
},{
    name: "ID автомата(по убыванию)",
    order_by: "machine_id",
    desc: true,
},{
    name: "Деньгам(по взрастанию)",
    order_by: "money_input",
    desc: false,
},{
    name: "Деньгам(по убыванию)",
    order_by: "money_input",
    desc: true,
},{
    name: "Воде(по взрастанию)",
    order_by: "water_amount",
    desc: false,
},{
    name: "Воде(по убыванию)",
    order_by: "water_amount",
    desc: true,
}];

const encashmentOrdering = [{
    name: "ID автомата(по взрастанию)",
    order_by: "machines_id",
    desc: false,
},{
    name: "ID автомата(по убыванию)",
    order_by: "machines_id",
    desc: true,
},{
    name: "Деньгам(по взрастанию)",
    order_by: "cash",
    desc: false,
},{
    name: "Деньгам(по убыванию)",
    order_by: "cash",
    desc: true,
},{
    name: "Инкассатору(по взрастанию)",
    order_by: "key_id",
    desc: false,
},{
    name: "Инкассатору(по убыванию)",
    order_by: "key_id",
    desc: true,
}];

const paymentTypes = [{
    name: "Наличные",
    code: 1,
},{
    name: "С ключа",
    code: 2,
},{
    name: "С карты",
    code: 3,
},{
    name: "Бонусы",
    code: 4,
},{
    name: "Телефон-ключ",
    code: 5,
}];

function mapStateToProps(state) {
    return {
        token: state.auth.token,
        orders: state.orders.orders,
        encashments: state.orders.encashments,
        machines: state.orders.machines.data,
        keysTransactions: state.orders.keysTransactions,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

class OrdersView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ordersData: [],
            encashmentsData: [],
            keysTransactionsData: [],
            timeoutEnabled: false,
            ordersRowsPerPage: 25,
            ordersPage: 1,
            encashmentsRowsPerPage: 25,
            encashmentsPage: 1,
            keysTransactionsRowPerPage: 25,
            keysTransactionsPage: 1,
            ordersTimeFrom: moment(new Date().setHours(0,0,0,0)),
            ordersTimeTo: moment(new Date()),
            ordersOrderByValue: "",
            ordersPaymentType: "",
            ordersMachines: [],
            encashmentTimeFrom: moment(new Date().setHours(0,0,0,0)),
            encashmentTimeTo: moment(new Date()),
            encashmentOrderByValue: "",
            encashmentMachines:[],
            keysTransactionsTimeFrom: moment(new Date().setHours(0,0,0,0)),
            keysTransactionsTimeTo: moment(new Date()),
            keysTransactionsOrderByValue: "",
            keysTransactionsSearchQuery: "",
        };
    }

    componentWillReceiveProps(nextProps, nextContext){
        const { classes } = nextProps;
        this.setState((prevState) => ({
            ...prevState,
            ordersData: nextProps.orders.isLoaded ? nextProps.orders.data.map((prop) => (
                [prop.id, prop.machine_id, prop.purchase_money, prop.water_amount, prop.cash_money, prop.key_money,
                    prop.cashless_money, prop.bonus_money, prop.payment_type, <span className={classes.keyHashSpan}>{prop.key_hash}</span>,
                    <Moment format="DD/MM/YYYY HH:mm:ss">{ prop.time }</Moment>]
            )).concat([["", "Итого:",nextProps.orders.purchase_sum, nextProps.orders.water, nextProps.orders.cash_sum,
                nextProps.orders.key_sum, nextProps.orders.cashless_sum, nextProps.orders.bonus_sum, "", "", ""]]) : prevState.ordersData,
            encashmentsData: nextProps.encashments.isLoaded ? nextProps.encashments.data.map((prop) => (
                [prop.id, prop.machine_id, prop.cash, <span className={classes.keyHashSpan}>{prop.key_hash}</span>,
                    prop.key_name, <Moment format="DD/MM/YYYY HH:mm:ss">{ prop.time }</Moment>]
            )).concat([["","Итого:", nextProps.encashments.cash, "", "", ""]]) : prevState.encashmentsData,
            keysTransactionsData: nextProps.keysTransactions.isLoaded ? nextProps.keysTransactions.data.map((prop) => (
                [prop.id, <span className={classes.keyHashSpan}>{`${prop.key_id}, ${prop.key_hash}`}</span>,
                    prop.key_name ,prop.machine_id ? `${prop.machine_id}, ${prop.machine_address}`
                    : null, prop.cash, prop.water_amount, prop.type === "deposit" ? "Пополнение" :  "Расход", prop.user_name,
                    <Moment format="DD/MM/YYYY HH:mm:ss">{ prop.time }</Moment>]
            )) : prevState.keysTransactionsData,
        }))
    }

    componentDidMount(){
        this.setState({
            timeoutEnabled: true,
        });
        this.getData()
    }

    componentWillUnmount(){
        this.setState({
            timeoutEnabled: false,
        })
    }


    getData(){
        this.props.getOrders(this.props.token, this.state.ordersPage, this.state.ordersRowsPerPage,
            ~~(this.state.ordersTimeFrom.valueOf()/1000), ~~(this.state.ordersTimeTo.valueOf()/1000),
            this.state.ordersPaymentType !== "" && paymentTypes[this.state.ordersPaymentType].code,
            this.state.ordersMachines.map((e) => e.value).join(),
            this.state.ordersOrderByValue !== "" && ordersOrderings[this.state.ordersOrderByValue].order_by,
            this.state.ordersOrderByValue !== "" && ordersOrderings[this.state.ordersOrderByValue].desc);
        this.props.getEncashments(this.props.token, this.state.encashmentsPage, this.state.encashmentsRowsPerPage,
            ~~(this.state.encashmentTimeFrom.valueOf()/1000), ~~(this.state.encashmentTimeTo.valueOf()/1000),
            this.state.encashmentMachines.map((e) => e.value).join(),
            this.state.encashmentOrderByValue !== "" && encashmentOrdering[this.state.encashmentOrderByValue].order_by,
            this.state.encashmentOrderByValue !== "" && encashmentOrdering[this.state.encashmentOrderByValue].desc);
        this.props.getKeysTransactions(this.props.token, this.state.keysTransactionsPage, this.state.keysTransactionsRowPerPage,
            ~~(this.state.keysTransactionsTimeFrom.valueOf()/1000), ~~(this.state.keysTransactionsTimeTo.valueOf()/1000),
            null, null, this.state.keysTransactionsSearchQuery);
        this.props.getOrdersMachines(this.props.token);
    }

    handleOrdersChangeRowsPerPage(e){
        if (e.target.value !== this.state.ordersRowsPerPage) {
            this.setState({
                ordersRowsPerPage: e.target.value
            }, this.getData);
        }
    }

    handleChangeState(type, data){
        this.setState({
            [type]: data
        }, this.getData)
    }

    handleEncashmentsChangeRowsPerPage(e){
        if (e.target.value !== this.state.encashmentsRowsPerPage) {
            this.setState({
                encashmentsRowsPerPage: e.target.value
            }, this.getData);
        }
    }

    //Function duplicates 3 times. Change it

    handleKeysTransactionsChangeRowsPerPage(e){
        if (e.target.value !== this.state.keysTransactionsRowPerPage) {
            this.setState({
                keysTransactionsRowPerPage: e.target.value
            }, this.getData);
        }
    }



    render(){
        const { classes, width } = this.props;
        return (
            <div>
                <Card>
                    <CardHeader color="success">
                        <Grid container>
                            <GridItem xs={5} s={10} md={10}>
                                <h4>Продажи</h4>
                            </GridItem>
                            <GridItem xs={7} s={2} md={2}>
                                <Button color="success" className={classes.headerButton} onClick={() => {get_file(this.props.token, "orders/xls",
                                    {
                                        from_time: ~~(this.state.ordersTimeFrom.valueOf()/1000),
                                        to_time: ~~(this.state.ordersTimeTo.valueOf()/1000),
                                        machines: this.state.ordersMachines.map((e) => e.value).join(),
                                    })}}>
                                    <ExcelIcon/>{`Сохранить${isWidthUp("md", width)? " в Excel": ""}`}
                                </Button>
                            </GridItem>
                        </Grid>
                    </CardHeader>
                    <CardBody>
                        <DateTimePicker value={this.state.ordersTimeFrom} onChange={(date) => this.handleChangeState("ordersTimeFrom", date)}
                                        ampm={false} invalidDateMessage="Неверный формат даты" label="От" className={classes.dateTime}
                                        okLabel="Сохранить" cancelLabel="Отменить" todayLabel="Сегодня" showTodayButton disableFuture
                        />
                        <DateTimePicker value={this.state.ordersTimeTo} onChange={(date) => this.handleChangeState("ordersTimeTo", date)}
                                        ampm={false} invalidDateMessage="Неверный формат даты" label="До" className={classes.dateTime}
                                        okLabel="Сохранить" cancelLabel="Отменить" todayLabel="Сегодня" showTodayButton disableFuture
                        />
                        <FormControl className={classes.selectWrapper}>
                            <InputLabel htmlFor="orders_order_by">Упорядочить по:</InputLabel>
                            <Select
                                value={this.state.ordersOrderByValue}
                                onChange={(e) => this.handleChangeState("ordersOrderByValue", e.target.value)}
                                inputProps={{
                                    name: 'orders_order_by',
                                    id: 'orders_order_by',
                                }}
                                className={classes.select}

                            >
                                <MenuItem value=""><em>По умолчанию</em></MenuItem>
                                {ordersOrderings.map((ordering, key) => (
                                    <MenuItem value={key} key={key}>{ordering.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl className={classes.selectWrapper}>
                            <InputLabel>Тип платежа:</InputLabel>
                            <Select
                                value={this.state.ordersPaymentType}
                                onChange={(e) => this.handleChangeState("ordersPaymentType", e.target.value)}
                                inputProps={{
                                    name: 'payment_type',
                                }}
                                className={classes.select}
                            >
                                <MenuItem value="">По умолчанию</MenuItem>
                                {paymentTypes.map((pt, key) => (
                                    <MenuItem value={key} key={key}>{pt.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Autocomplete
                            suggestions={this.props.machines.map(e => ({value: e.id, label: e.address}))}
                            selectedValue={this.state.ordersMachines}
                            label="Автоматы"
                            placeholder="Выберите автоматы..."
                            onChange={(e) => this.handleChangeState("ordersMachines",e !== null ? e : [])}
                            isMulti
                        />
                        <Table
                            tableHead={["ID", "ID аппарата", "Cумма покупки", "Продано воды", "Внесено наличных",
                                "Внесено с ключа", "Внесено безнал", "Внесено бонусов", "Тип платежа", "HEX ключа", "Дата"]}
                            tableData={this.state.ordersData}
                            tablePagination={(<TablePagination count={this.props.orders.count || 0}
                                                           onChangePage={(e, page) => this.handleChangeState("ordersPage",page + 1)}
                                                           page={this.state.ordersPage - 1} rowsPerPage={this.state.ordersRowsPerPage}
                                                           labelDisplayedRows={({from, to, count}) => `${from}-${to} из ${count}`}
                                                           labelRowsPerPage="Строк на страницу:" component="div"
                                                           onChangeRowsPerPage={(e) => this.handleOrdersChangeRowsPerPage(e)}
                            />)}
                        />
                    </CardBody>
                </Card>
                <Card>
                    <CardHeader color="primary">
                        <Grid container>
                            <GridItem xs={5} s={10} md={10}>
                                <h4>Инкассации</h4>
                            </GridItem>
                            <GridItem xs={7} s={2} md={2}>
                                <Button color="primary" className={classes.headerButton} onClick={() => {get_file(this.props.token, "encashments/xls",
                                    {
                                        from_time: ~~(this.state.encashmentTimeFrom.valueOf()/1000),
                                        to_time: ~~(this.state.encashmentTimeTo.valueOf()/1000),
                                        machines: this.state.encashmentMachines.map((e) => e.value).join(),
                                    })}}>
                                    <ExcelIcon/>{`Сохранить${isWidthUp("md", width)? " в Excel": ""}`}
                                </Button>
                            </GridItem>
                        </Grid>
                    </CardHeader>
                    <CardBody>
                        <DateTimePicker value={this.state.encashmentTimeFrom} onChange={(date) => this.handleChangeState("encashmentTimeFrom", date)}
                                        ampm={false} invalidDateMessage="Неверный формат даты" label="От" className={classes.dateTime}
                                        okLabel="Сохранить" cancelLabel="Отменить" todayLabel="Сегодня" showTodayButton disableFuture
                        />
                        <DateTimePicker value={this.state.encashmentTimeTo} onChange={(date) => this.handleChangeState("encashmentTimeTo", date)}
                                        ampm={false} invalidDateMessage="Неверный формат даты" label="До" className={classes.dateTime}
                                        okLabel="Сохранить" cancelLabel="Отменить" todayLabel="Сегодня" showTodayButton disableFuture
                        />
                        <FormControl className={classes.selectWrapper}>
                            <InputLabel htmlFor="encashment_order_by">Упорядочить по:</InputLabel>
                            <Select
                                value={this.state.encashmentOrderByValue}
                                onChange={(e) => this.handleChangeState("encashmentOrderByValue", e.target.value)}
                                inputProps={{
                                    name: 'encashment_order_by',
                                    id: 'encashment_order_by',
                                }}
                                className={classes.select}

                            >
                                <MenuItem value=""><em>По умолчанию</em></MenuItem>
                                {encashmentOrdering.map((ordering, key) => (
                                    <MenuItem value={key} key={key}>{ordering.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Autocomplete
                            suggestions={this.props.machines.map(e => ({value: e.id, label: e.address}))}
                            selectedValue={this.state.encashmentMachines}
                            label="Автоматы"
                            placeholder="Выберите автоматы..."
                            onChange={(e) => this.handleChangeState("encashmentMachines",e !== null ? e : [])}
                            isMulti
                        />
                        <Table
                            tableHead={["ID", "ID аппарата", "Инкассиравано", "HEX ключа", "Владелец ключа", "Дата"]}
                            tableData={this.state.encashmentsData}
                            tablePagination={(<TablePagination count={this.props.encashments.count || 0}
                                                           onChangePage={(e, page) => this.handleChangeState("encashmentsPage", page + 1)}
                                                           page={this.state.encashmentsPage - 1} rowsPerPage={this.state.encashmentsRowsPerPage}
                                                           labelDisplayedRows={({from, to, count}) => `${from}-${to} из ${count}`}
                                                           labelRowsPerPage="Строк на страницу:" component="div"
                                                           onChangeRowsPerPage={(e) => this.handleEncashmentsChangeRowsPerPage(e)}
                            />)}
                        />
                    </CardBody>
                </Card>
                <Card>
                    <CardHeader color="warning">
                        <Grid container>
                            <GridItem xs={12} s={9} md={9}>
                                <h4>Действия по ключам</h4>
                            </GridItem>
                        </Grid>
                    </CardHeader>
                    <CardBody>
                        <CustomInput
                            labelText="Поиск по ключам"
                            formControlProps={{
                                className: classes.keySearchInput,
                                fullWidth: false
                            }}
                            inputProps={{
                                value: this.state.keysTransactionsSearchQuery,
                                onChange: e => this.handleChangeState("keysTransactionsSearchQuery", e.target.value)
                            }}
                        />
                        <DateTimePicker value={this.state.keysTransactionsTimeFrom} onChange={(date) => this.handleChangeState("keysTransactionsTimeFrom", date)}
                                        ampm={false} invalidDateMessage="Неверный формат даты" label="От" className={classes.dateTime}
                                        okLabel="Сохранить" cancelLabel="Отменить" todayLabel="Сегодня" showTodayButton disableFuture
                        />
                        <DateTimePicker value={this.state.keysTransactionsTimeTo} onChange={(date) => this.handleChangeState("keysTransactionsTimeTo", date)}
                                        ampm={false} invalidDateMessage="Неверный формат даты" label="До" className={classes.dateTime}
                                        okLabel="Сохранить" cancelLabel="Отменить" todayLabel="Сегодня" showTodayButton disableFuture
                        />
                        <Table
                            tableHead={["ID", "Ключ", "Имя ключа","Аппарат", "Сумма", "Литры", "Тип", "Пользователь", "Дата"]}
                            tableData={this.state.keysTransactionsData}
                            tablePagination={(<TablePagination count={this.props.keysTransactions.count || 0}
                                                           onChangePage={(e, page) => this.handleChangeState("keysTransactionsPage", page + 1)}
                                                           page={this.state.keysTransactionsPage - 1} rowsPerPage={this.state.keysTransactionsRowPerPage}
                                                           labelDisplayedRows={({from, to, count}) => `${from}-${to} из ${count}`}
                                                           labelRowsPerPage="Строк на страницу:" component="div"
                                                           onChangeRowsPerPage={(e) => this.handleKeysTransactionsChangeRowsPerPage(e)}
                            />)}
                        />
                    </CardBody>
                </Card>
                <ReactInterval timeout={15000} enabled={this.state.timeoutEnabled} callback={() => this.getData()}/>
            </div>
        )
    }
}

OrdersView.propTypes = {
    getOrders: PropTypes.func,
    getEncashments: PropTypes.func,
    getOrdersMachines: PropTypes.func,
    getKeysTransactions: PropTypes.func,
    token: PropTypes.string,
    orders: PropTypes.shape({
        data: PropTypes.array,
        isLoading: PropTypes.bool,
        isLoaded: PropTypes.bool,
        count: PropTypes.number,
        page: PropTypes.number,
        pages: PropTypes.number,
    }),
    encashments: PropTypes.shape({
        data: PropTypes.array,
        isLoading: PropTypes.bool,
        isLoaded: PropTypes.bool,
        count: PropTypes.number,
        page: PropTypes.number,
        pages: PropTypes.number,
    }),
    keysTransactions: PropTypes.shape({
        data: PropTypes.array,
        isLoading: PropTypes.bool,
        isLoaded: PropTypes.bool,
        count: PropTypes.number,
        page: PropTypes.number,
        pages: PropTypes.number,
    }),
    machines: PropTypes.arrayOf(PropTypes.number)
};

export default connect(mapStateToProps, mapDispatchToProps)(withWidth()(withStyles(ordersStyle,{withTheme: true})(OrdersView)));


// WEBPACK FOOTER //
// ./src/views/Orders/Orders.jsx